// Chakra defaults (v1) -- we are extending
// https://github.com/chakra-ui/chakra-ui/blob/v1/packages/theme/src/foundations/spacing.ts
export const space = {
    0: '0px',
    px: '1px',
    1: '0.25rem', // 4px
    2: '0.5rem', // 8px
    2.5: '0.875rem', // 10px,
    3: '0.75rem', // 12px
    3.5: '0.875rem', // 14px
    4: '1rem', // 16px
    5: '1.25rem', // 20px
    6: '1.5rem', // 24px
    7: '1.75rem', // 28px
    8: '2rem', // 32px
    9: '2.25rem', // 36px
    10: '2.5rem', // 40px
    11: '2.75rem', // 44px
    12: '3rem', // 48px
    14: '3.5rem', // 56px
    16: '4rem', // 64px
    18: '4.5rem', // 72px
    20: '5rem', // 80px
    24: '6rem', // 96px
    25: '6.25rem', // 100px
    32: '8rem', // 128px
    40: '10rem', // 160px
};
